/* eslint-disable*/
import { useEffect, useState } from "react";
import moment from "moment";
import { filterData } from "util/array";

export const useMetaData = (preDataForm, idActivity) => {
    const [metadata, setMetadata] = useState({
        draftsEnabled: false,
        templatesEnabled: false,
        schedulable: true,
        programable: true,
        idActivity,
    });
    useEffect(() => {
        const { nonWorkingDays, enabledWeekDays, firstWorkingDate = new Date(), maxDaysToSchedule } = preDataForm;
        setMetadata((state) => ({
            ...state,
            nonWorkingDays,
            enabledWeekDays,
            firstWorkingDate,
            maxDaysToSchedule,
        }));
    }, [preDataForm]);
    return [metadata];
};

export const formatAccount = (accountWally) => (accountWally?.number ? `*****${accountWally.number.slice(-4)}` : "");

export const getDefaultValueDate = (metadata) => moment(metadata.firstWorkingDate, "YYYY-MM-DDTHH:mm:ss.000Z");

export const formatPhone = (phone) => {
    const value = phone
        .replaceAll("+", "")
        .replaceAll(/ /g, "")
        .replaceAll("-", "")
        .replaceAll("(", "")
        .replaceAll(")", "");

    if (!isNaN(parseFloat(value)) && isFinite(value)) {
        return value;
    } else {
        return "";
    }
};

export const useFilterBeneficiaries = (beneficiariesPeople) => {
    const [listPeople, setListPeople] = useState();
    useEffect(() => {
        setListPeople(beneficiariesPeople);
    }, [beneficiariesPeople]);
    const filterBeneficiaries = (value, beneficiaries, keys) => {
        if (value !== "") {
            const data = filterData(beneficiaries, keys, value);
            setListPeople(data);
        } else {
            setListPeople(beneficiaries);
        }
    };
    return [listPeople, filterBeneficiaries];
};

export const extractCountryAndNumber = (phoneNumber) => {
    const parts = phoneNumber.split(/[-\s]/);
    const [countryCode, ...rest] = parts;
    return { countryCode: formatPhone(countryCode), phoneNumber: formatPhone(rest.join('')) };
};
